import { getQueryParamsAndQueryString } from '@thoughtspot/env-flags';
import { FEATURE_FLAG_NAMES, isFeatureEnabled, isOrgsOnFTEnabled, } from '@thoughtspot/feature-service';
import { canSetupVersionControl, getCurrentOrgId, getScimBaseUrl, getSubscriptionType, getTeamsConfig, getTSAdminUserGuid, getUserGuid, getUserName, hasPrivilege, isAdminAuthV2PagesExperienceEnabled, isAdminModernExperienceEnabled, isComsEnabled, isCustomChartEnabled, isCustomizeEmailFromAdminEnabled, isCustomRegionEnabled, isIamV2OidcEnabled, isMfaEnabled, isModernFeatureManagementEnabled, isModularHomeExperienceEnabled, isOrgUiEnabled, isRolesEnabled, isSaaSCluster, isScimPerOrgEnabled, isVariablesUIEnabled, NavigationVersion, PRIVILEGES, SubscriptionType, } from '@thoughtspot/session-service';
import { isOktaEnabled } from '@thoughtspot/system-config-service';
import _ from 'lodash';
import { GETTING_STARTED_URLS } from './dependents';
import { hasModernFMPrivilege } from './feature-management-privilege';
export const getUrlForGetStarted = () => {
    if (getTeamsConfig()) {
        if (getSubscriptionType() === SubscriptionType.DEVELOPER_EDITION) {
            return GETTING_STARTED_URLS.DEVELOPER_EDITION;
        }
        if (getSubscriptionType() === SubscriptionType.FREE_TRIAL) {
            return GETTING_STARTED_URLS.FREE_TRIAL;
        }
        return getTeamsConfig().faqPageUrl;
    }
    return '';
};
const SPOTTER_APP_BASE = '/?primaryNavHidden=true&embedApp=true&intercomEnabled=false#/copilot';
const CONFIG_APP_BASE = '/managementconsole/?hideNavigation=true&intercomEnabled=false#/config';
const USERACTIVITY_GUID = 'bea79810-145f-4ad0-a02c-4177a6e7d861';
const APPPERFORMANCE_GUID = 'a1cd9526-f25a-443b-8a35-75d0adc6e04f';
const BILLINGSAAS_GUID = '41a39422-2da0-4601-9d4a-59c27181c5f5';
const BILLINGONPREM_GUID = '9beaacbf-e65b-4416-b110-238d109c3531';
const QUERYSTATS_GUID = '0ee6fb0f-e7bf-4042-8d5d-c90d0412bf6c';
const OBJECTUSAGES_GUID = '74852035-9624-4fac-b352-200fa8506b14';
const INDEXINGQUERIES_GUID = 'befd912d-0c44-4c1a-9980-d84d455bc43a';
const AIBILIVEBOARD_GUID = '3e08c798-a5cb-4ae9-b54e-c03bf35243ef';
const VISUAL_EMBED_LIVEBOARD = 'visual-embed-liveboard';
const USER_ACTIVITY_TAB_ID = '7ab58fe5-d137-4e58-995d-ebd11850d472';
const OBJECT_USAGES_TAB_ID = '01006fc1-3b13-4144-8654-325a3a1fbe1d';
const AIBI_LIVEBOARD_TAB_ID = '452fc06a-7656-4d90-b985-5fe2056b2c63';
export var SidebarNavItemId;
(function (SidebarNavItemId) {
    SidebarNavItemId["FeatureManagement"] = "feature-management";
})(SidebarNavItemId || (SidebarNavItemId = {}));
const addTab = (condition, config) => condition ? [config] : [];
const getBillingGuid = () => {
    const isSaas = isSaaSCluster();
    if (isSaas) {
        return BILLINGSAAS_GUID;
    }
    return BILLINGONPREM_GUID;
};
const isMenuItemEnabled = (condition, privilege) => {
    if (!condition) {
        return false;
    }
    if (isRolesEnabled()) {
        return hasPrivilege(privilege);
    }
    return condition;
};
const isVersionControlEnabled = (isVersionControlFlagEnabled) => {
    if (isRolesEnabled()) {
        return ((canSetupVersionControl() ||
            hasPrivilege(PRIVILEGES.ADMINISTRATION)) &&
            isVersionControlFlagEnabled);
    }
    return isVersionControlFlagEnabled;
};
export const appendPreferredLocaleToUrl = (url, locale) => {
    if (!locale)
        return url;
    const separator = url.includes('?') ? '&' : '?';
    const parts = url.split('#');
    return `${parts[0]}${separator}locale=${locale}#${parts[1]}`;
};
export const isNavigationHubActive = () => {
    const { queryParams } = getQueryParamsAndQueryString();
    return queryParams.navigationVersion === NavigationVersion.V3;
};
export const getUsersUrl = (V1_SEGMENT) => {
    const MAIN_APP_BASE = `${V1_SEGMENT}/?primaryNavHidden=true&embedApp=true&intercomEnabled=false#/admin`;
    return `${MAIN_APP_BASE}/user-management/users`;
};
export const getStyleCustomizationUrl = (V1_SEGMENT) => {
    const STYLECUSTOMIZATION_APP_BASE = `${V1_SEGMENT}/?primaryNavHidden=true&embedApp=true&intercomEnabled=false#/admin`;
    return `${STYLECUSTOMIZATION_APP_BASE}/settings/style-customization`;
};
export const sidebarTabsMapping = (t, V1_SEGMENT) => {
    const MAIN_APP_BASE = `${V1_SEGMENT}/?primaryNavHidden=true&embedApp=true&intercomEnabled=false#/admin`;
    const MAIN_PINBOARD_BASE_V2 = `${V1_SEGMENT}/?primaryNavHidden=true&embedApp=true&isPinboardV2Enabled&intercomEnabled=false=true#/pinboard`;
    return {
        users: {
            id: 'user-management-users',
            label: t('adminSection.userManagement.tabUsers.name'),
        },
        spotter: {
            id: 'spotter-users-list',
            ...(getUserName() === 'tsadmin'
                ? { url: `${SPOTTER_APP_BASE}/users-list` }
                : {}),
            label: t('copilot.leftNavrBar.header'),
        },
        groups: {
            id: 'user-management-groups',
            label: t('adminSection.userManagement.tabGroups.name'),
        },
        roles: {
            id: 'user-management-roles',
            label: t('adminSection.userManagement.tabRoles.name'),
        },
        userManagement: {
            id: 'modern-user-management',
            label: t('adminUI.captions.ADMIN_USER_MANAGEMENT'),
        },
        activeDir: {
            id: 'authentication-active-directory',
            ...(isAdminAuthV2PagesExperienceEnabled()
                ? {}
                : { url: `${CONFIG_APP_BASE}/active-directory` }),
            label: t('adminSection.authentication.activedirectory'),
        },
        internalAuth: {
            id: 'authentication-local',
            ...(isAdminAuthV2PagesExperienceEnabled()
                ? {}
                : { url: `${CONFIG_APP_BASE}/internal` }),
            label: t('adminSection.authentication.local'),
        },
        saml: {
            id: 'authentication-saml',
            url: `${CONFIG_APP_BASE}/saml`,
            label: t('adminSection.authentication.saml'),
        },
        smtp: {
            id: 'settings-smtp',
            label: t('adminSection.settings.smtp'),
        },
        helpCustomization: {
            id: 'settings-help-customization',
            label: t('adminSection.helpCustomization.tabHeader'),
        },
        emailCustomizations: {
            id: 'email-customizations',
            label: t('adminSection.emailCustomization.tabHeader'),
        },
        actionCustomization: {
            id: 'settings-action-customization',
            url: `${MAIN_APP_BASE}/settings/action-customization`,
            label: t('adminSection.actionCustomization.tabHeader'),
        },
        styleCustomization: {
            id: 'settings-style-customization-react',
            label: t('adminSection.styleCustomization.tabHeader'),
        },
        saml_v2: {
            id: 'authentication-saml',
            label: t(isIamV2OidcEnabled()
                ? 'adminSection.authentication.ssoLabel'
                : 'adminSection.authentication.saml'),
        },
        mfa: {
            id: 'authentication-mfa',
            label: t('adminSection.authentication.mfa'),
        },
        ssl: {
            id: 'settings-ssl',
            label: t('adminSection.settings.ssl'),
        },
        provisioning: {
            id: 'authentication-provisioning',
            label: t('adminSection.provisioning.title'),
        },
        reverseSSH: {
            id: 'settings-rev-ssh',
            label: t('adminSection.settings.reversessh'),
        },
        security: {
            id: 'settings-security',
            label: t('adminSection.settings.security'),
        },
        nas: {
            id: 'backup-storage',
            label: t('adminSection.backup.nas'),
        },
        backup: {
            id: 'backup-storage',
            label: t('system.backupStorage.title'),
        },
        snapshot: {
            id: 'backup-storage',
            label: t('adminSection.backup.snapshot'),
        },
        alerts: {
            id: 'system-alerts',
            label: t('adminSection.system.alert'),
        },
        clusterDetails: {
            id: 'system-cluster-details',
            label: t('adminSection.system.cluster'),
        },
        tableStatus: {
            id: 'system-table-status',
            label: t('adminSection.system.tableStatus'),
        },
        upgrade: {
            id: 'system-upgrade',
            label: t('adminSection.upgrade.name'),
        },
        scheduledMaintenance: {
            id: 'scheduled-maintenance',
            label: t('adminSection.scheduleMaintenance.name'),
        },
        userActivity: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${USERACTIVITY_GUID}_${USER_ACTIVITY_TAB_ID}`,
            label: t('adminSection.userActivity.tabHeader'),
        },
        appPerformance: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${APPPERFORMANCE_GUID}`,
            label: t('adminSection.appPerformance.tabHeader'),
        },
        objectUsages: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${OBJECTUSAGES_GUID}_${OBJECT_USAGES_TAB_ID}`,
            label: t('adminSection.objectUsages.tabHeader'),
        },
        indexingQueries: {
            id: 'system-activities-indexing-queries',
            url: `${MAIN_PINBOARD_BASE_V2}/${INDEXINGQUERIES_GUID}`,
            label: t('adminSection.indexingQueries.tabHeader'),
        },
        aibiLiveboard: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${AIBILIVEBOARD_GUID}_${AIBI_LIVEBOARD_TAB_ID}`,
            label: t('adminSection.aibiLiveboard.tabHeader'),
        },
        creditConsumption: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${getBillingGuid()}`,
            label: t('adminSection.creditConsumption.tabHeader'),
        },
        org: {
            id: 'org-management-organizations',
            label: isAdminModernExperienceEnabled()
                ? t('MANAGE_ORG_TEXT')
                : t('orgs.organization'),
        },
        userAgreement: {
            id: 'user-agreement',
            label: t('adminSection.system.legal.name'),
        },
        chartCustomization: {
            id: 'chart-customization',
            label: t('adminSection.chartCustomization.title'),
        },
        csvUpload: {
            id: 'csv-upload',
            label: t('csvUpload.admin.leftPanel.title'),
        },
        versionControlSystem: {
            id: 'version-control-system',
            label: t('vcs.admin.leftPanel.title'),
        },
        featureManagement: {
            id: 'feature-management',
            label: t('adminSection.feature_management.title'),
        },
        earlyAccessFeature: {
            id: 'tscli-ui-early_access_feature',
            label: t('adminSection.early_access_feature.title'),
        },
        downloadsAndSchedules: {
            id: 'tscli-ui-downloadsAndSchedules',
            label: t('adminSection.downloadsAndSchedules.title'),
        },
        DataModeling: {
            id: 'tscli-ui-dataModelling',
            label: t('adminSection.data_modeling.name'),
        },
        Administration: {
            id: 'tscli-ui-administration',
            label: t('adminSection.administration.name'),
        },
        applicationSettings: {
            id: 'application-settings',
            label: t('admin.applicationSettings.title'),
        },
        queryStats: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${QUERYSTATS_GUID}`,
            label: t('adminSection.queryStats.tabHeader'),
        },
        pricing: {
            id: 'pricing',
            label: t('teams.plan_options'),
        },
        manageSubscription: {
            id: 'manage-subscription',
            label: t('teams.manage_subscription.title'),
        },
        dataUsage: {
            id: 'data-usage',
            label: t('teams.data_usage.title'),
        },
        getStartedWithTE: {
            id: 'get-started-with-te',
            url: getUrlForGetStarted(),
            label: t('setup.started'),
            shouldOpenGetStartedWithTEUrl: true,
        },
        contactUs: {
            id: 'contact-us',
            shouldOpenIntercom: true,
            label: t('teams.contact_us'),
        },
        homePageDiscovery: {
            id: 'homepage-and-discovery',
            label: t('adminSection.homePageAppExperience.title'),
        },
        variables: {
            id: 'variables',
            label: t('variables.page.title'),
        },
    };
};
function filterTabs(tabsConfig) {
    const result = {};
    if (Object.keys(tabsConfig).length === 0) {
        return tabsConfig;
    }
    Object.keys(tabsConfig).forEach(item => {
        if (tabsConfig[item]) {
            Object.keys(tabsConfig[item]).forEach(subitem => {
                if (subitem !== '__typename' &&
                    subitem &&
                    tabsConfig[item][subitem]) {
                    result[item] = tabsConfig[item];
                }
            });
        }
    });
    return result;
}
export function sideBarCopilotConfig(t, tabsConfig, V1_SEGMENT) {
    const tabs = [];
    const sidebarConfig = sidebarTabsMapping(t, V1_SEGMENT);
    const config = filterTabs(!tabsConfig.status ? {} : tabsConfig.status);
    if (config.user_management) {
        tabs.push({
            label: t('adminSection.userManagement.tabHeader'),
            navItems: [
                ...addTab(isMenuItemEnabled(true, PRIVILEGES.USER_ADMINISTRATION), sidebarConfig.users),
            ],
        });
    }
    if (config.application_settings && getUserName() === 'tsadmin') {
        tabs.push({
            label: t('adminSection.application_settings.name'),
            navItems: [
                ...addTab(isMenuItemEnabled(true, PRIVILEGES.USER_ADMINISTRATION), sidebarConfig.spotter),
            ],
        });
    }
    if (config.teams && isOrgsOnFTEnabled()) {
        tabs.push({
            label: t('account_details'),
            navItems: [...addTab(isOrgsOnFTEnabled(), sidebarConfig.pricing)],
        });
    }
    return tabs;
}
function getSubscriptionHasGroupAccess() {
    const isGroupsFreeTrialFlag = isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_GROUPS_FREE_TRIAL);
    return isGroupsFreeTrialFlag
        ? [
            SubscriptionType.DEVELOPER_EDITION,
            SubscriptionType.FREE_TRIAL,
        ].includes(getSubscriptionType())
        : getSubscriptionType() === SubscriptionType.DEVELOPER_EDITION;
}
export const hasAnyUserManagementTab = (visibility) => visibility.users ||
    visibility.groups ||
    visibility.roles ||
    visibility.authentication;
export const getLegacyUserManagementVisibility = (tabsConfig, isAllOrgContext = false) => {
    const config = filterTabs(tabsConfig?.status ?? tabsConfig ?? {});
    const hasUserManagement = !!config.user_management;
    const hasAuthentication = !!config.authentication;
    const users = hasUserManagement &&
        (isOrgUiEnabled() && isAllOrgContext
            ? isMenuItemEnabled(true, PRIVILEGES.ADMINISTRATION)
            : isMenuItemEnabled(true, PRIVILEGES.USER_ADMINISTRATION));
    const isAllOrgsView = isOrgUiEnabled() && isAllOrgContext;
    const groups = !isAllOrgsView &&
        hasUserManagement &&
        isMenuItemEnabled(getSubscriptionHasGroupAccess() ||
            (config.user_management.groups &&
                (!isOrgsOnFTEnabled() ||
                    getUserGuid() === getTSAdminUserGuid())), PRIVILEGES.GROUP_ADMINISTRATION);
    const roles = !isAllOrgsView &&
        hasUserManagement &&
        isMenuItemEnabled(isRolesEnabled() && config.user_management.roles, PRIVILEGES.ROLE_ADMINISTRATION);
    const authentication = isOrgUiEnabled() && isAllOrgContext
        ? isMenuItemEnabled(true, PRIVILEGES.ADMINISTRATION)
        : hasAuthentication &&
            !!(config.authentication.saml ||
                config.authentication.internal_auth ||
                config.authentication.active_dir);
    return {
        authentication,
        groups,
        roles,
        users,
    };
};
export const USER_MANAGEMENT_ITEM_ID = 'user_management';
export const USER_MANAGEMENT_TAB_IDS = {
    users: 'users',
    groups: 'groups',
    roles: 'roles',
    authentication: 'authentication',
};
export const getUserManagementItemTabs = (sidebarConfigResponse) => {
    const sections = sidebarConfigResponse?.Data?.sections;
    if (!sections)
        return [];
    const entry = sections
        .flatMap(section => section?.itemTabs ?? [])
        .find(tab => tab?.id === USER_MANAGEMENT_ITEM_ID);
    return entry?.tabs ?? [];
};
export const getUserManagementVisibility = (sidebarConfigResponse) => {
    const itemTabs = getUserManagementItemTabs(sidebarConfigResponse);
    const users = itemTabs.includes(USER_MANAGEMENT_TAB_IDS.users);
    const groups = itemTabs.includes(USER_MANAGEMENT_TAB_IDS.groups);
    const roles = itemTabs.includes(USER_MANAGEMENT_TAB_IDS.roles);
    const authentication = itemTabs.includes(USER_MANAGEMENT_TAB_IDS.authentication);
    return {
        authentication,
        groups,
        roles,
        users,
    };
};
export function sideBarConfig(t, tabsConfig, externalAuth = false, purchaseSuccessful = false, isAllOrgContext = false, V1_SEGMENT = '') {
    const tabs = [];
    const sidebarConfig = sidebarTabsMapping(t, V1_SEGMENT);
    const config = filterTabs(!tabsConfig.status ? {} : tabsConfig.status);
    const userManagementVisibility = getLegacyUserManagementVisibility(config, isAllOrgContext);
    if (config.org_management) {
        tabs.push({
            label: isAdminModernExperienceEnabled()
                ? t('orgs.organization')
                : t('MANAGE_ORG_TEXT'),
            navItems: [
                ...addTab(isMenuItemEnabled(config.org_management.org, PRIVILEGES.ORG_ADMINISTRATION), sidebarConfig.org),
            ],
        });
    }
    if (isAdminModernExperienceEnabled()) {
        if (hasAnyUserManagementTab(userManagementVisibility)) {
            tabs.push({
                label: t('adminUI.captions.USER_LABEL'),
                navItems: [...addTab(true, sidebarConfig.userManagement)],
            });
        }
    }
    else {
        if (config.user_management) {
            tabs.push({
                label: t('adminSection.userManagement.tabHeader'),
                navItems: [
                    ...addTab(userManagementVisibility.users, sidebarConfig.users),
                    ...addTab(userManagementVisibility.groups, sidebarConfig.groups),
                    ...addTab(userManagementVisibility.roles, sidebarConfig.roles),
                ],
            });
        }
        if (config.authentication) {
            tabs.push({
                label: t('adminSection.authentication.name'),
                navItems: [
                    ...addTab(config.authentication.internal_auth, sidebarConfig.internalAuth),
                    ...addTab(config.authentication.saml, externalAuth || isAdminAuthV2PagesExperienceEnabled()
                        ? sidebarConfig.saml_v2
                        : sidebarConfig.saml),
                    ...addTab(config.authentication.saml &&
                        isOktaEnabled() &&
                        isMfaEnabled() &&
                        (isOrgUiEnabled() ? isAllOrgContext : true), sidebarConfig.mfa),
                    ...addTab((config.authentication.saml ||
                        config.authentication.scim) &&
                        (isOrgUiEnabled()
                            ? isAllOrgContext ||
                                (getCurrentOrgId() !== 0 &&
                                    isScimPerOrgEnabled())
                            : true) &&
                        getScimBaseUrl().length !== 0, sidebarConfig.provisioning),
                    ...addTab(config.authentication.active_dir, sidebarConfig.activeDir),
                ],
            });
        }
    }
    if (config.system_activities) {
        tabs.push({
            label: t('adminSection.system_activities.name'),
            navItems: [
                ...addTab(config.system_activities.user_activity, sidebarConfig.userActivity),
                ...addTab(config.system_activities.object_usages, sidebarConfig.objectUsages),
                ...addTab(config.system_activities.app_performance, sidebarConfig.appPerformance),
                ...addTab(config.system_activities.indexing_queries, sidebarConfig.indexingQueries),
                ...addTab(config.system_activities.ai_bi_liveboard, sidebarConfig.aibiLiveboard),
            ],
        });
    }
    let appSettingsTab = null;
    if (config.application_settings) {
        const isHelpCustomizationEnabled = config.application_settings.help_customization &&
            !isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_PENDO_HELP);
        appSettingsTab = {
            label: t('adminSection.application_settings.name'),
            navItems: [
                ...addTab(config.application_settings.feature_management &&
                    isModernFeatureManagementEnabled() &&
                    hasModernFMPrivilege(), sidebarConfig.featureManagement),
                ...addTab(isHelpCustomizationEnabled, sidebarConfig.helpCustomization),
                ...addTab(config.application_settings.email_customizations &&
                    isComsEnabled() &&
                    isCustomizeEmailFromAdminEnabled(), sidebarConfig.emailCustomizations),
                ...addTab(config.application_settings.style_customization, sidebarConfig.styleCustomization),
                ...addTab(config.application_settings.chart_customization &&
                    (isCustomChartEnabled() || isCustomRegionEnabled()), sidebarConfig.chartCustomization),
                ...addTab(!isAdminModernExperienceEnabled() &&
                    config.application_settings.csv_upload, sidebarConfig.csvUpload),
                ...addTab(config.application_settings.early_access_feature &&
                    (!isModernFeatureManagementEnabled() ||
                        !hasModernFMPrivilege()), sidebarConfig.earlyAccessFeature),
                ...addTab(isVersionControlEnabled(config.application_settings.version_control_system), sidebarConfig.versionControlSystem),
                ...addTab(!isAdminModernExperienceEnabled() &&
                    config.application_settings.data_modelling, sidebarConfig.DataModeling),
                ...addTab(!isAdminModernExperienceEnabled() &&
                    config.application_settings.downloads_and_schedules, sidebarConfig.downloadsAndSchedules),
                ...addTab(config.application_settings.homepage_and_discovery &&
                    isModularHomeExperienceEnabled(), sidebarConfig.homePageDiscovery),
                ...addTab(!isAdminModernExperienceEnabled() &&
                    config.application_settings.administration, sidebarConfig.Administration),
                ...addTab(isAdminModernExperienceEnabled() &&
                    !!config.application_settings.config_management, sidebarConfig.applicationSettings),
                ...addTab(config.application_settings.variables &&
                    isVariablesUIEnabled() &&
                    (isOrgUiEnabled() ? isAllOrgContext : false), sidebarConfig.variables),
            ],
        };
        tabs.push(appSettingsTab);
    }
    if (config.billing) {
        tabs.push({
            label: t('adminSection.billing.name'),
            navItems: [
                ...addTab(config.billing.credit_consumption, sidebarConfig.creditConsumption),
                ...addTab(config.billing.query_stats, sidebarConfig.queryStats),
            ],
        });
    }
    if (config.teams && isOrgsOnFTEnabled()) {
        tabs.push({
            label: t('account_details'),
            navItems: [
                ...addTab(isOrgsOnFTEnabled(), sidebarConfig.pricing),
                ...addTab(isOrgsOnFTEnabled() &&
                    (getSubscriptionType() ===
                        SubscriptionType.TEAMS_EDITION ||
                        purchaseSuccessful), sidebarConfig.manageSubscription),
                ...addTab(isOrgsOnFTEnabled(), sidebarConfig.dataUsage),
                ...addTab(isOrgsOnFTEnabled(), sidebarConfig.contactUs),
                ...addTab(isOrgsOnFTEnabled(), sidebarConfig.getStartedWithTE),
            ],
        });
    }
    if (config.system) {
        tabs.push({
            label: t('adminSection.system.name'),
            navItems: [
                ...addTab(config.system.ssl, sidebarConfig.ssl),
                ...addTab(config.system.rev_ssh, sidebarConfig.reverseSSH),
                ...addTab(config.system.security?.ssl ||
                    config.system.security?.rev_ssh, sidebarConfig.security),
                ...addTab(config.system.scheduled_maintenance, sidebarConfig.scheduledMaintenance),
                ...addTab(config.system.smtp, sidebarConfig.smtp),
                ...addTab(config.system?.backup_storage?.nas ||
                    config.system?.backup_storage?.snapshot, sidebarConfig.backup),
                ...addTab(config.system.alerts, sidebarConfig.alerts),
                ...addTab(config.system.nas, sidebarConfig.nas),
                ...addTab(config.system.snapshot, sidebarConfig.snapshot),
                ...addTab(config.system.cluster_details, sidebarConfig.clusterDetails),
                ...addTab(config.system.upgrade, sidebarConfig.upgrade),
                ...addTab(config.system.table_status, sidebarConfig.tableStatus),
                ...addTab(config.system.user_agreement, sidebarConfig.userAgreement),
            ],
        });
    }
    Object.keys(config).map(key => {
        Object.keys(config[key]).map(subKey => {
            if (config.tscli_ui && config.tscli_ui.includes(subKey)) {
                const isHiddenByModernAppSettings = isAdminModernExperienceEnabled() &&
                    (subKey === 'administration' ||
                        subKey === 'downloadsAndSchedules' ||
                        subKey === 'dataModelling' ||
                        subKey === 'csv_upload');
                if (config[key][subKey] &&
                    !isHiddenByModernAppSettings &&
                    !(subKey === 'early_access_feature' &&
                        isModernFeatureManagementEnabled())) {
                    tabs.map((item) => {
                        if (item.label === t(`adminSection.${key}.name`)) {
                            const navIds = item.navItems.map((navItem) => navItem.id);
                            if (_.findIndex(navIds, id => id === `tscli-ui-${subKey}`) >= 0) {
                                return;
                            }
                            item.navItems.unshift({
                                id: `tscli-ui-${subKey}`,
                                label: t(`adminSection.${subKey}.name`),
                            });
                        }
                    });
                }
            }
        });
    });
    if (appSettingsTab) {
        const fmIndex = appSettingsTab.navItems.findIndex((navItem) => navItem.id === SidebarNavItemId.FeatureManagement);
        if (fmIndex > 0) {
            const fmItem = appSettingsTab.navItems[fmIndex];
            appSettingsTab.navItems = [
                fmItem,
                ...appSettingsTab.navItems.filter((_, i) => i !== fmIndex),
            ];
        }
    }
    return tabs;
}
export function getSideBarConfig(t, tabsConfig, externalAuth = false, purchaseSuccessful = false, isAllOrgContext = false, isCopilotEnabled = false, V1_SEGMENT) {
    if (isCopilotEnabled) {
        return sideBarCopilotConfig(t, tabsConfig, V1_SEGMENT);
    }
    return sideBarConfig(t, tabsConfig, externalAuth, purchaseSuccessful, isAllOrgContext, V1_SEGMENT);
}
const getDisplayLabelFromKey = (key) => key.replace(/[_-]+/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
const buildSidebarItemAliases = (V1_SEGMENT) => {
    const PINBOARD_BASE = `${V1_SEGMENT}/?primaryNavHidden=true&embedApp=true&isPinboardV2Enabled&intercomEnabled=false=true#/pinboard`;
    return {
        org_management: {
            id: 'modern-org-management',
            labelKey: 'adminSection.sidebar.orgmanagement',
        },
        user_management: {
            id: 'modern-user-management',
            labelKey: 'adminSection.userManagement.tabHeader',
        },
        application_settings: {
            id: 'application-settings',
            labelKey: 'adminSection.application_settings.name',
        },
        feature_management: {
            id: 'feature-management',
            labelKey: 'adminSection.feature_management.title',
        },
        variables: {
            id: 'variables',
            labelKey: 'variables.page.title',
        },
        version_control: {
            id: 'version-control-system',
            labelKey: 'vcs.admin.leftPanel.title',
        },
        customisation: {
            id: 'settings-style-customization-react',
            labelKey: 'adminSection.sidebar.customisation',
        },
        ai_settings: {
            id: 'tscli-ui-sage_feature',
            labelKey: 'adminSection.sidebar.aisettings',
        },
        search_spot_iq: {
            id: 'tscli-ui-search',
            labelKey: 'tscli.config.search.title',
        },
        onboarding: {
            id: 'tscli-ui-onboarding',
            labelKey: 'adminSection.onboarding.name',
        },
        user_adoption: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${USERACTIVITY_GUID}_${USER_ACTIVITY_TAB_ID}`,
            labelKey: 'adminSection.userActivity.tabHeader',
        },
        performance_tracking: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${APPPERFORMANCE_GUID}`,
            labelKey: 'adminSection.appPerformance.tabHeader',
        },
        object_usages: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${OBJECTUSAGES_GUID}_${OBJECT_USAGES_TAB_ID}`,
            labelKey: 'adminSection.objectUsages.tabHeader',
        },
        indexing_queries: {
            id: 'system-activities-indexing-queries',
            url: `${PINBOARD_BASE}/${INDEXINGQUERIES_GUID}`,
            labelKey: 'adminSection.indexingQueries.tabHeader',
        },
        credit_consumption: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${getBillingGuid()}`,
            labelKey: 'adminSection.creditConsumption.tabHeader',
        },
        ai_bi_stats: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${AIBILIVEBOARD_GUID}_${AIBI_LIVEBOARD_TAB_ID}`,
            labelKey: 'adminSection.aibiLiveboard.tabHeader',
        },
        billing_query_stats: {
            id: `${VISUAL_EMBED_LIVEBOARD}_${QUERYSTATS_GUID}`,
            labelKey: 'adminSection.queryStats.tabHeader',
        },
        scheduled_maintenance: {
            id: 'scheduled-maintenance',
            labelKey: 'adminSection.scheduleMaintenance.name',
        },
        terms: {
            id: 'user-agreement',
            labelKey: 'adminSection.system.legal.name',
        },
    };
};
const getSidebarNavItem = (translate, aliases, itemId) => {
    const alias = aliases[itemId];
    if (!alias) {
        return { id: itemId, label: getDisplayLabelFromKey(itemId) };
    }
    return {
        id: alias.id,
        ...(alias.url ? { url: alias.url } : {}),
        label: alias.labelKey
            ? translate(alias.labelKey)
            : alias.label ?? getDisplayLabelFromKey(itemId),
    };
};
export function getSidebarSectionsFromResponse(t, sidebarConfigResponse, V1_SEGMENT = '', purchaseSuccessful = false) {
    const aliases = buildSidebarItemAliases(V1_SEGMENT);
    const sections = (sidebarConfigResponse?.Data?.sections?.map(section => {
        const navItems = (section?.items ?? [])
            .filter((itemId) => !!itemId)
            .map(itemId => getSidebarNavItem(t, aliases, itemId));
        return {
            label: section?.title ?? '',
            navItems,
        };
    }) ?? []).filter(section => section.navItems.length > 0);
    if (isOrgsOnFTEnabled()) {
        const sidebarConfig = sidebarTabsMapping(t, V1_SEGMENT);
        const accountSection = {
            label: t('account_details'),
            navItems: [
                ...addTab(true, sidebarConfig.pricing),
                ...addTab(getSubscriptionType() === SubscriptionType.TEAMS_EDITION ||
                    purchaseSuccessful, sidebarConfig.manageSubscription),
                ...addTab(true, sidebarConfig.dataUsage),
                ...addTab(true, sidebarConfig.contactUs),
                ...addTab(true, sidebarConfig.getStartedWithTE),
            ],
        };
        const monitorIndex = sections.findIndex(s => s.label === 'monitor');
        if (monitorIndex >= 0) {
            sections.splice(monitorIndex, 0, accountSection);
        }
        else {
            sections.push(accountSection);
        }
    }
    return sections;
}
export const showQuickLinks = false;
//# sourceMappingURL=sidebar-config.js.map